module.exports = __webpack_public_path__ + "img/wxUrl.a5c8d555.png";